































































































































































import {
  defineComponent,
  ref,
  reactive,
  computed,
  PropType,
  watch,
} from '@vue/composition-api';
import Store from '@/store';
import {
  ITemplateSectionField, ITemplateSectionFieldsValidation, VForm,
} from '@/types';
import InboundOutboundFields from './InboundOutboundFields.vue';
import CalculationLogicDialog from './CalculationLogicDialog.vue';

export default defineComponent({
  components: {
    InboundOutboundFields,
    CalculationLogicDialog,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    field: {
      type: Object as PropType<ITemplateSectionField>,
      default: () => {},
      required: true,
    },
    sectionFieldData: {
      type: Object as PropType<ITemplateSectionFieldsValidation>,
      default: () => {},
      required: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
    isPublished: {
      type: Boolean,
      required: true,
    },
    templateId: {
      type: String,
      required: true,
    },
    subsectionIndex: {
      type: Number,
      required: false,
    },
  },

  setup(props) {
    const form = ref(null as unknown as VForm);
    const tab = null;
    const dialog = ref(false);
    const conditonalLogicDialog = ref();
    const apisCalled = ref(false);
    const calculateLogicDialog = ref();

    // Validation for Length of Label
    const rules = {
      lengthRule: (v: string) => (v && v.length <= 100) || 'Label must be less than 100 characters',
    };

    const isLoading = computed(() => Store.getters['conditionalLogic/getLoading']);

    const sectionFieldName = props.sectionName;

    // TODO remove ID key when updating validation
    const fieldData = reactive({
      fieldId: '',
      id: 0,
      inboundMapping: '',
      outboundMapping: '',
      inboundOverwrite: true,
      name: '',
      value: '',
      required: false,
      type: '',
      prefix: '',
      suffix: '',
      readonly: false,
      validation: {
        min: '',
        max: '',
        mask: '',
      },
    }) as ITemplateSectionField;

    /**
     * Method triggered when user opens dialog
     * searches field data based off index position
     * returns field data stored and assigns it to main field data obj
     */
    const getFieldData = () => {
      const fieldSavedData = Store.getters['templateCustomisation/getSectionFieldData']({
        sectionName: sectionFieldName,
        fieldIndex: props.index,
        subsectionIndex: props.subsectionIndex,
      }) as ITemplateSectionField;

      Object.keys(fieldSavedData).forEach((key) => {
        fieldData[key] = fieldSavedData[key];
      });

      if (!fieldSavedData.validation) return;
      Object.keys(fieldSavedData.validation).forEach((key) => {
        if (fieldSavedData.validation && fieldData.validation) {
          fieldData.validation[key] = fieldSavedData.validation[key];
        }
      });
    };

    /**
     * Closes dialog box
     */
    const closeDialog = () => {
      Store.commit('conditionalLogic/resetConditionalLogicAlarm');
      dialog.value = false;

      getFieldData();
    };

    /*
    * apisCalled is set when the user has hit 'confirm' and is adding values to the field
    * when the loading is finished and the we closeDialog() and reset value
    */
    watch(isLoading, () => {
      if (!isLoading.value && apisCalled.value) {
        closeDialog();
        apisCalled.value = false;
      }
    });
    watch(dialog, () => {
      if (dialog.value === false && conditonalLogicDialog.value) conditonalLogicDialog.value.clearFields(true);
      if (dialog.value === false && calculateLogicDialog.value) calculateLogicDialog.value.getCalculateLogic();
    });

    /**
     * Returns title card text depending on published status
     */
    const getCardTitleText = computed(() => {
      let title = `Configure '${fieldData.name}' ${props.field ? props.field.type : ''} Component`;
      if (props.isPublished) title = title.replace('Configure', 'View');
      return title;
    });

    /**
     * Return cancel button text depending on published status
     */
    const getCloseBtnText = computed(() => (props.isPublished ? 'Close' : 'Cancel'));

    /**
     * Save updated data into vuex
     */
    const saveValues = () => {
      // Dont allow user to confirm if Label validation fails
      const isValidated = form.value.validate();
      if (!isValidated) return;

      const updateFieldDetails = {
        sectionName: sectionFieldName,
        index: props.index,
        subsectionIndex: props.subsectionIndex,
        fieldData,
      };

      apisCalled.value = true;
      Store.dispatch(
        'templateCustomisation/updateIndividualField',
        updateFieldDetails,
      );

      /*
      * if there is no conditional logic to delete or add we can straight away close the dialog
      * if there is the dialog stays open and we fire delete alarms
      */
      if (Store.getters['conditionalLogic/getDeletedConditionalLogicIds'].length === 0 && Store.getters['conditionalLogic/getAddedConditionalLogic'].length === 0) closeDialog();
      else {
        Store.dispatch('conditionalLogic/deleteAlarms', {
          workOrderTemplateId: props.templateId,
          calledFromStatusLogic: false,
        });
      }
    };

    return {
      tab,
      form,
      dialog,
      closeDialog,
      saveValues,
      fieldData,
      getFieldData,
      sectionFieldName,
      rules,
      getCardTitleText,
      getCloseBtnText,
      conditonalLogicDialog,
      calculateLogicDialog,
      isLoading,
    };
  },
});
